// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31q1W","title":"Header_title__PVd9o","left":"Header_left__163gF","clinicName":"Header_clinicName__3kVyO"};